export const adminMenu = [
    {
        label: 'Asset',
        icon: 'pi pi-fw pi-table',
        items: [
            { label: 'Asset', icon: 'pi pi-fw pi-table', to: '/asset' },
            { label: 'Soft Asset', icon: 'pi pi-fw pi-table', to: '/soft/asset' },
        ]
    },
    { separator: true },
    {
        label: 'Vendor',
        icon: 'pi pi-fw pi-briefcase',
        items: [
            { label: 'Vendor', icon: 'pi pi-fw pi-briefcase', to: '/vendor' },
        ]
    },
    { separator: true },
    {
        label: 'Employee',
        icon: 'pi pi-fw pi-briefcase',
        items: [
            { label: 'Employee', icon: 'pi pi-fw pi-briefcase', to: '/employee' },
        ]
    },
    { separator: true },
    {
        label: 'Others',
        icon: 'pi pi-fw pi-briefcase',
        items: [
            { label: 'Others', icon: 'pi pi-fw pi-briefcase', to: '/others' },
        ]
    },
    { separator: true },
    {
        label: 'Report',
        icon: 'pi pi-fw pi-briefcase',
        items: [
            { label: 'All Details', icon: 'pi pi-fw pi-briefcase', to: '/report' },
            { label: 'Category Vs Company', icon: 'pi pi-fw pi-briefcase', to: '/report-by-category-vs-company' },
            { label: 'Department Vs Category', icon: 'pi pi-fw pi-briefcase', to: '/report-by-department-vs-category' },
            { label: 'Category Vs Brand', icon: 'pi pi-fw pi-briefcase', to: '/report-by-category-vs-brand' },
        ]
    },
    { separator: true },
    {
        label: 'Users',
        icon: 'pi pi-fw pi-tablet',
        items: [
            { label: 'Users', icon: 'pi pi-fw pi-tablet', to: '/users' },
        ]
    },
    { separator: true },
    {
        label: 'Settings',
        icon: 'pi pi-spin pi-cog',
        items: [
            { label: 'Change password', icon: 'pi pi-spin pi-cog', to: '/change_password' },
            { label: 'Logout', icon: 'pi pi-fw pi-sign-out', to: '/logout' },
        ]
    },
];

export const staffMenu = [
    {
        label: 'Asset',
        icon: 'pi pi-fw pi-table',
        items: [
            { label: 'Asset', icon: 'pi pi-fw pi-table', to: '/asset' },
            { label: 'Soft Asset', icon: 'pi pi-fw pi-table', to: '/soft/asset' },
        ]
    },
    { separator: true },
    {
        label: 'Vendor',
        icon: 'pi pi-fw pi-briefcase',
        items: [
            { label: 'Vendor', icon: 'pi pi-fw pi-briefcase', to: '/vendor' },
        ]
    },
    { separator: true },
    {
        label: 'Employee',
        icon: 'pi pi-fw pi-briefcase',
        items: [
            { label: 'Employee', icon: 'pi pi-fw pi-briefcase', to: '/employee' },
        ]
    },
    { separator: true },
    {
        label: 'Others',
        icon: 'pi pi-fw pi-briefcase',
        items: [
            { label: 'Others', icon: 'pi pi-fw pi-briefcase', to: '/others' },
        ]
    },
    { separator: true },
    {
        label: 'Report',
        icon: 'pi pi-fw pi-briefcase',
        items: [
            { label: 'All Details', icon: 'pi pi-fw pi-briefcase', to: '/report' },
            { label: 'Category Vs Company', icon: 'pi pi-fw pi-briefcase', to: '/report-by-category-vs-company' },
            { label: 'Department Vs Category', icon: 'pi pi-fw pi-briefcase', to: '/report-by-department-vs-category' },
            { label: 'Category Vs Brand', icon: 'pi pi-fw pi-briefcase', to: '/report-by-category-vs-brand' },
        ]
    },
    { separator: true },
    {
        label: 'Settings',
        icon: 'pi pi-spin pi-cog',
        items: [
            { label: 'Change password', icon: 'pi pi-spin pi-cog', to: '/change_password' },
            { label: 'Logout', icon: 'pi pi-fw pi-sign-out', to: '/logout' },
        ]
    },
];


export const menu = [
    {
        label: 'Dashboard',
        icon: 'pi pi-fw pi-home',
        items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' }]
    },
    {
        label: 'Asset',
        icon: 'pi pi-fw pi-table',
        items: [
            { label: 'Asset', icon: 'pi pi-fw pi-table', to: '/asset' },
        ]
    },
    { separator: true },
    {
        label: 'Report',
        icon: 'pi pi-fw pi-briefcase',
        items: [
            { label: 'Report', icon: 'pi pi-fw pi-briefcase', to: '/report' },
        ]
    },
    { separator: true },
    {
        label: 'Users',
        icon: 'pi pi-fw pi-tablet',
        items: [
            { label: 'Users', icon: 'pi pi-fw pi-tablet', to: '/users' },
        ]
    },
    { separator: true },
    {
        label: 'Settings',
        icon: 'pi pi-spin pi-cog',
        items: [
            { label: 'Change password', icon: 'pi pi-spin pi-cog', to: '/change_password' },
            { label: 'Logout', icon: 'pi pi-fw pi-sign-out', to: '/logout' },
        ]
    },
    { separator: true },
    {
        label: 'UI Kit',
        icon: 'pi pi-fw pi-id-card',
        items: [
            { label: 'Form Layout', icon: 'pi pi-fw pi-id-card', to: '/formlayout' },
            { label: 'Input', icon: 'pi pi-fw pi-check-square', to: '/input' },
            { label: 'Float Label', icon: 'pi pi-fw pi-bookmark', to: '/floatlabel' },
            { label: 'Invalid State', icon: 'pi pi-fw pi-exclamation-circle', to: '/invalidstate' },
            { label: 'Button', icon: 'pi pi-fw pi-mobile', to: '/button', className: 'rotated-icon' },
            { label: 'Table', icon: 'pi pi-fw pi-table', to: '/table' },
            { label: 'List', icon: 'pi pi-fw pi-list', to: '/list' },
            { label: 'Tree', icon: 'pi pi-fw pi-share-alt', to: '/tree' },
            { label: 'Panel', icon: 'pi pi-fw pi-tablet', to: '/panel' },
            { label: 'Overlay', icon: 'pi pi-fw pi-clone', to: '/overlay' },
            { label: 'Media', icon: 'pi pi-fw pi-image', to: '/media' },
            { label: 'Menu', icon: 'pi pi-fw pi-bars', to: '/menu' },
            { label: 'Message', icon: 'pi pi-fw pi-comment', to: '/messages' },
            { label: 'File', icon: 'pi pi-fw pi-file', to: '/file' },
            { label: 'Chart', icon: 'pi pi-fw pi-chart-bar', to: '/chart' },
            { label: 'Misc', icon: 'pi pi-fw pi-circle-off', to: '/misc' }
        ]
    },
    { separator: true },
    {
        label: 'PrimeBlocks',
        icon: 'pi pi-fw pi-prime',
        items: [
            { label: 'Free Blocks', icon: 'pi pi-fw pi-eye', to: '/blocks', badge: 'NEW', badgeStyle: { width: '40px' } },
            { label: 'All Blocks', icon: 'pi pi-fw pi-globe', url: 'https://www.primefaces.org/primeblocks-react', target: '_blank' }
        ]
    },
    { separator: true },
    {
        label: 'Utilities',
        icon: 'pi pi-fw pi-compass',
        items: [
            { label: 'Icons', icon: 'pi pi-fw pi-prime', to: '/icons' },
            { label: 'PrimeFlex', icon: 'pi pi-fw pi-desktop', url: 'https://www.primefaces.org/primeflex', target: '_blank' }
        ]
    },
    {
        label: 'Pages',
        icon: 'pi pi-fw pi-pencil',
        items: [
            { label: 'Crud', icon: 'pi pi-fw pi-pencil', to: '/crud' },
            { label: 'Calendar', icon: 'pi pi-fw pi-calendar-plus', to: '/calendar' },
            { label: 'Timeline', icon: 'pi pi-fw pi-calendar', to: '/timeline' },
            { label: 'Landing', icon: 'pi pi-fw pi-user-plus', url: 'assets/pages/landing.html', target: '_blank' },
            { label: 'Login', icon: 'pi pi-fw pi-sign-in', to: '/login' },
            { label: 'Invoice', icon: 'pi pi-fw pi-dollar', to: '/invoice' },
            { label: 'Invoice2', icon: 'pi pi-fw pi-dollar', to: '/invoice2' },
            { label: 'Help', icon: 'pi pi-fw pi-question-circle', to: '/help' },
            { label: 'Error', icon: 'pi pi-fw pi-times-circle', to: '/error' },
            { label: 'Not Found', icon: 'pi pi-fw pi-exclamation-circle', to: '/notfound' },
            { label: 'Access Denied', icon: 'pi pi-fw pi-lock', to: '/access' },
            { label: 'Empty', icon: 'pi pi-fw pi-circle-off', to: '/empty' }
        ]
    },
    { separator: true },
    {
        label: 'Hierarchy',
        icon: 'pi pi-fw pi-align-left',
        items: [
            {
                label: 'Submenu 1',
                icon: 'pi pi-fw pi-align-left',
                items: [
                    {
                        label: 'Submenu 1.1',
                        icon: 'pi pi-fw pi-align-left',
                        items: [
                            { label: 'Submenu 1.1.1', icon: 'pi pi-fw pi-align-left' },
                            { label: 'Submenu 1.1.2', icon: 'pi pi-fw pi-align-left' },
                            { label: 'Submenu 1.1.3', icon: 'pi pi-fw pi-align-left' }
                        ]
                    },
                    {
                        label: 'Submenu 1.2',
                        icon: 'pi pi-fw pi-align-left',
                        items: [{ label: 'Submenu 1.2.1', icon: 'pi pi-fw pi-align-left' }]
                    }
                ]
            },
            {
                label: 'Submenu 2',
                icon: 'pi pi-fw pi-align-left',
                items: [
                    {
                        label: 'Submenu 2.1',
                        icon: 'pi pi-fw pi-align-left',
                        items: [
                            { label: 'Submenu 2.1.1', icon: 'pi pi-fw pi-align-left' },
                            { label: 'Submenu 2.1.2', icon: 'pi pi-fw pi-align-left' }
                        ]
                    },
                    {
                        label: 'Submenu 2.2',
                        icon: 'pi pi-fw pi-align-left',
                        items: [{ label: 'Submenu 2.2.1', icon: 'pi pi-fw pi-align-left' }]
                    }
                ]
            }
        ]
    },
    { separator: true },
    {
        label: 'Start',
        icon: 'pi pi-fw pi-download',
        items: [
            { label: 'Buy Now', icon: 'pi pi-fw pi-shopping-cart', command: () => window.open('https://www.primefaces.org/store', '_blank') },
            { label: 'Documentation', icon: 'pi pi-fw pi-info-circle', to: '/documentation' }
        ]
    }
];
